module.exports = __webpack_public_path__ + "img/sky.77b224b0.png";